import { ToneCardComponent } from '../../featuredcategory/viewmodel/tonecard/tonecardcomponent';
import { ToneCardViewImpl } from '../../featuredcategory/viewmodel/tonecard/tonecardview';
import { ToneCardAPIModel } from '../../featuredcategory/viewmodel/tonecard/tonecardapimodel';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { APIModelHandler, APIModel } from '../../../../toolkit/uicomponentapimodel';
import { WishlistToneCardAPIModelImpl } from './wishlisttonecardapimodel';
import { UIComponentHandler, UIDataModel } from '../../../../toolkit/uicomponent';
import { UIComponentView } from '../../../../toolkit/uicomponentview';
import { WishlistToneCardViewImpl } from './wishlisttonecardview';


export class WishlistToneCardComponent extends ToneCardComponent
{
    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new WishlistToneCardAPIModelImpl(applicationContext, apiModelHandler);
    }
    onDeleteClicked(): void 
    {
        (this.getView() as ToneCardViewImpl).showLoader(); 
        (this.getAPIModel() as ToneCardAPIModel).deleteTone(this.props.toneDto);
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new WishlistToneCardViewImpl(applicationContext, uiComponentHandler);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/wishlist/tones/wishlisttonecardcomponent.tsx